import {useState, useEffect} from "react";
import {useParams, useHistory} from "react-router-dom";
import Loading from "../../../utils/loading";
import QuantityEntry from "../../../utils/quantityEntry";
import { GetProveedores, GetPurchaseSuggestedDetail, PostPurchaseSuggested, UpdateOrderNote, GetOrdenCompraNotas, SaveOrdenCompraNotas } from "../../../../services/purchaseServices";
import "../../../../css/purchase-receipt.css";

const PurchaseSuggestedDetail = () => {
    const {id} = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(null);
    const [tab, setTab] = useState("Pedidos");
    const [cantidadSolicitada, setCantidadSolicitada] = useState(10);
    const [proveedores, setProveedores] = useState([]);
    const [notas, setNotas] = useState("");
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [editingNoteText, setEditingNoteText] = useState("");
    const [showOcNotas, setShowOcNotas] = useState(false);
    const [ocNotas, setOcNotas] = useState("");
    const [ocNotasSaving, setOcNotasSaving] = useState(false);
    const [ocNotasProveedorId, setOcNotasProveedorId] = useState(null);

    useEffect(() => {
        cargar();
        cargarProveedores();
    }, [id]);

    const cargarProveedores = async () => {
        try {
            const data = await GetProveedores();
            setProveedores(data);
        } catch (error) {
            console.error("Error al cargar proveedores", error);
        }
    };

    const cargar = async () => {
        try {
            setLoading(true);
            const data = await GetPurchaseSuggestedDetail(id);
            setItem(data);
            setNotas(data.notas || "");
            
         
            if (data.cantidadSolicitada !== undefined) {
                setCantidadSolicitada(data.cantidadSolicitada);
            } else if (data.sugerido !== undefined) {
                setCantidadSolicitada(data.sugerido);
            }
        } catch (error) {
            console.error("Error al cargar detalle de sugerido", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            if (!item.proveedorId) {
                alert("Por favor seleccione un proveedor");
                return;
            }
            
            if(cantidadSolicitada < 0) {
                alert("La cantidad solicitada no puede ser negativa");
                return;
            }

            setLoading(true);
            const dataToSave = {
                proveedorId: item.proveedorId,
                cantidadSolicitada: cantidadSolicitada,
                notas: notas
            };

            await PostPurchaseSuggested(id, dataToSave);

            if (ocNotas) {
                await SaveOrdenCompraNotas(item.proveedorId, item.fechaEntrega, ocNotas);
            }

            history.push({
                pathname: "/purchase-suggested",
                state: history.location.state
            });
        } catch (error) {
            console.error("Error al guardar el sugerido", error);
            alert("Error al guardar el sugerido");
        } finally {
            setLoading(false);
        }
    };

    const handleEditNote = (pedidoPartidaId, currentNote) => {
        setEditingNoteId(pedidoPartidaId);
        setEditingNoteText(currentNote || "");
    };

    const handleSaveNote = async (pedidoPartidaId) => {
        try {
            setLoading(true);
      
            await UpdateOrderNote(pedidoPartidaId, editingNoteText);
            
            // Update the note in the item's pedidosDetalle array
            const updatedPedidos = item.pedidosDetalle.map(p => 
                (p.idPartida || p.id) === pedidoPartidaId ? { ...p, nota: editingNoteText } : p
            );
            setItem({ ...item, pedidosDetalle: updatedPedidos });
            setEditingNoteId(null);
            setEditingNoteText("");
        } catch (error) {
            console.error("Error al guardar la nota", error);
            alert("Error al guardar la nota del pedido");
        } finally {
            setLoading(false);
        }
    };

    const handleCancelEditNote = () => {
        setEditingNoteId(null);
        setEditingNoteText("");
    };

    const loadOcNotas = async (proveedorId, fechaEntrega) => {
        try {
            const data = await GetOrdenCompraNotas(proveedorId, fechaEntrega);
            setOcNotas(data.notas || "");
            setOcNotasProveedorId(proveedorId);
        } catch (error) {
            console.error("Error al cargar notas OC", error);
        }
    };

    useEffect(() => {
        if (showOcNotas && item?.proveedorId && item?.fechaEntrega && item.proveedorId !== ocNotasProveedorId) {
            loadOcNotas(item.proveedorId, item.fechaEntrega);
        }
    }, [showOcNotas, item?.proveedorId]);

    const handleOcNotasBlur = async () => {
        if (!item?.proveedorId || !item?.fechaEntrega) return;
        try {
            setOcNotasSaving(true);
            await SaveOrdenCompraNotas(item.proveedorId, item.fechaEntrega, ocNotas);
        } catch (error) {
            console.error("Error al guardar notas OC", error);
            alert("Error al guardar las notas de la OC");
        } finally {
            setOcNotasSaving(false);
        }
    };

    if (!item && !loading) return null;

    return (
        <div id="purchase-suggested-detail" className="suggested--detail-container">
            {loading && <Loading />}
            
            {item && (
                <>
                    <div className="suggested--detail-header">
                        <div className="title">{item.descripcion}</div>
                        <div className="close-btn" onClick={() => history.push({
                            pathname: "/purchase-suggested",
                            state: history.location.state
                        })}>X</div>
                    </div>

                    <div className="suggested--detail-content">
                        <div className="suggested--detail-main">
                            <div className="col-img">
                                <img className="thumbnail" src={item.imageUrl} alt={item.descripcion} />
                            </div>
                            <div className="col-info">
                                <div className="detail-row">
                                    <span className="label">Proveedor:</span>
                                    <div className="proveedor-row">
                                        <select
                                            className="value-bAt ox select-control"
                                            value={item.proveedorId}
                                            onChange={(e) => setItem({...item, proveedorId: parseInt(e.target.value)})}
                                        >
                                            <option value="">Seleccione un proveedor</option>
                                            {proveedores.map(p => (
                                                <option key={p.id} value={p.id}>{p.nombre}</option>
                                            ))}
                                        </select>
                                        <button
                                            className={`oc-notas-toggle-btn${showOcNotas ? " active" : ""}`}
                                            onClick={() => setShowOcNotas(!showOcNotas)}
                                            title="Notas de OC"
                                        >✎</button>
                                    </div>
                                </div>
                                {showOcNotas && (
                                    <div className="suggested--oc-notas">
                                        <div className="oc-notas-header">
                                            <span className="label">Notas OC:</span>
                                            {ocNotasSaving && <span className="oc-notas-saving">Guardando...</span>}
                                        </div>
                                        <textarea
                                            className="notes-textarea"
                                            value={ocNotas}
                                            onChange={(e) => setOcNotas(e.target.value)}
                                            onBlur={handleOcNotasBlur}
                                            placeholder="Sin notas"
                                            rows={3}
                                        />
                                    </div>
                                )}
                                <div className="detail-grid">
                                    <div className="label">Pedidos:</div>
                                    <div className="value">{item.pedidos} {item.unidad}</div>
                                    
                                    <div className="label">Existencia:</div>
                                    <div className="value">{item.existencia} {item.unidad}</div>
                                    
                                    <div className="label">Faltante:</div>
                                    <div className="value">{item.faltante} {item.unidad}</div>
                                    
                                    <div className="label">MOQ:</div>
                                    <div className="value">{item.moq} {item.unidad}</div>
                                    
                                    <div className="label">Sugerido:</div>
                                    <div className="value">{item.sugerido} {item.unidad}</div>
                                    
                                    <div className="label">Tiempo vida:</div>
                                    <div className="value">{item.tiempoVida}</div>
                                    
                                    <div className="label">Venta promedio :</div>
                                    <div className="value">{item.ventaPromedio} {item.unidad}</div>
                                    
                                    <div className="label">Última compra:</div>
                                    <div className="value multi-line">
                                        {item.ultimaCompra ? (
                                            <>
                                                <div>{item.ultimaCompra.fecha}</div>
                                                <div>{item.ultimaCompra.cantidad} {item.unidad}</div>
                                                <div>{item.ultimaCompra.precio}</div>
                                            </>
                                        ) : (
                                            <div>N/A</div>
                                        )}
                                    </div>
                                    
                                    <div className="label align-center">Cantidad solicitada:</div>
                                    <div className="value">
                                        <QuantityEntry 
                                            value={cantidadSolicitada}
                                            onValueChanged={(val) => setCantidadSolicitada(val)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="suggested--detail-notes">
                            <div className="notes-label">Notas:</div>
                            <textarea 
                                className="notes-textarea"
                                value={notas}
                                onChange={(e) => setNotas(e.target.value)}
                                rows={4}
                            />
                        </div>

                        <div className="suggested--detail-actions">
                            <button className="save-btn" onClick={handleSave}>Guardar</button>
                        </div>

                        <div className="suggested--detail-tabs">
                            <div 
                                className={`tab ${tab === "Pedidos" ? "active" : ""}`} 
                                onClick={() => setTab("Pedidos")}
                            >
                                Pedidos
                            </div>
                            <div 
                                className={`tab ${tab === "Historial de ventas" ? "active" : ""}`} 
                                onClick={() => setTab("Historial de ventas")}
                            >
                                Historial de ventas
                            </div>
                        </div>

                        <div className="suggested--detail-tab-content">
                            {tab === "Pedidos" && (
                                <div className="orders-list">
                                    {item.pedidosDetalle.map((p) => (
                                        <div key={p.idPartida || p.id} className="order-item">
                                            <div className="order-header">
                                                <div className="order-id">Pedido <strong>{p.id}</strong></div>
                                                <div className="order-qty"><strong>{p.cantidad} {item.unidad}</strong></div>
                                            </div>
                                            <div className="order-client">{p.cliente}</div>
                                            {editingNoteId === (p.idPartida || p.id) ? (
                                                <div className="order-footer">
                                                    <textarea 
                                                        className="notes-textarea"
                                                        value={editingNoteText}
                                                        onChange={(e) => setEditingNoteText(e.target.value)}
                                                        rows={2}
                                                        autoFocus
                                                    />
                                                    <div style={{display: 'flex', gap: '0.5rem', marginTop: '0.5rem'}}>
                                                        <button className="save-btn" onClick={() => handleSaveNote(p.idPartida || p.id)}>Guardar</button>
                                                        <button className="cancel-btn" onClick={handleCancelEditNote}>Cancelar</button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="order-footer">
                                                    {p.nota &&  <div className="order-note">"{p.nota }"</div>}
                                                    <button className="edit-note-btn" onClick={() => handleEditNote(p.idPartida || p.id, p.nota)}>Editar nota</button>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                            {tab === "Historial de ventas" && (
                                <div className="history-list">
                                    {/* Mockup de historial */}
                                    <p style={{textAlign: 'center', padding: '2rem'}}>Sin historial reciente</p>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default PurchaseSuggestedDetail;
